











import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
   name: 'Option',
   components: {
    ArgumentHandler: () => import('@/components/extrinsics/ArgumentHandler.vue'),
  }
})
export default class Option extends Vue {
  @Prop() public argument!: any;
  @Prop({ default: false }) public readonly disabled!: boolean;
  @Prop({ default: null }) public readonly defaultValue!: any;

  get value() {
    return this.defaultValue && Object.fromEntries(Array.from(this.defaultValue.value));
  }

  get arg() {
    return this.argument && { ...this.argument.sub, name: this.argument.name }
  }

}
